module.exports = __webpack_public_path__ + "3ea73f478db2daa07a81b868e5a985c1.jpg";